export default function MurfreesboroTestimonialsSection() {
  const testimonials = [
    {
      name: "Amanda Chen",
      title: "MTSU Study Abroad Student",
      initials: "AC",
      text: "My study abroad paperwork was due in two weeks and I didn't have a passport. They had it ready in 3 days. I made it to my semester in Spain and it was the experience of a lifetime. Absolute lifesavers!",
      date: "Verified Review",
    },
    {
      name: "Mark Patterson",
      title: "Nissan Smyrna Engineer",
      initials: "MP",
      text: "I travel to Japan quarterly for Nissan and always use this service. They know exactly what business travelers need — fast turnaround, accurate documentation, and zero surprises. Worth every dollar.",
      date: "Verified Review",
    },
    {
      name: "Sarah Williams",
      title: "Murfreesboro Resident",
      initials: "SW",
      text: "Our family of five needed passports for a European vacation. They handled all five applications simultaneously and gave us a family discount. Got everything back in four days. Incredible service!",
      date: "Verified Review",
    },
    {
      name: "Dr. James Fletcher",
      title: "Healthcare Professional, Murfreesboro",
      initials: "JF",
      text: "I had a medical conference in Geneva and my passport expired. Called Monday, had a new passport Thursday. The team is extraordinarily efficient. I've recommended them to every colleague I know.",
      date: "Verified Review",
    },
    {
      name: "Ashley Nguyen",
      title: "MTSU International Student",
      initials: "AN",
      text: "As an international student I needed my passport renewed urgently for a trip home. They understood the complications of my situation and handled everything perfectly. Beyond grateful.",
      date: "Verified Review",
    },
    {
      name: "Robert Davis",
      title: "Nashville Metro Professional",
      initials: "RD",
      text: "I live in Murfreesboro and work in Nashville. When I needed my passport fast, I didn't want to fight downtown Nashville traffic. These guys handled it locally and saved me an entire day. Game changer.",
      date: "Verified Review",
    },
  ];

  return (
    <section className="bg-white py-20 md:py-28">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <div className="text-center mb-14">
          <p className="text-[#F6C344] text-xs font-bold uppercase tracking-[0.2em] mb-3">Testimonials</p>
          <h2 className="font-serif text-3xl md:text-4xl font-bold text-[#1A365D] mb-4">
            Trusted by Murfreesboro Families
          </h2>
          <p className="text-gray-500 max-w-2xl mx-auto text-base leading-relaxed">
            Real stories from MTSU students, Rutherford County professionals, and Murfreesboro families who trusted us with their most important travel document.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {testimonials.map((t, index) => (
            <div key={index} className="bg-[#F7F8FA] rounded-xl p-7 hover:bg-[#EEF2F8] transition-all">
              <div className="flex items-center mb-2">
                {[...Array(5)].map((_, i) => (
                  <i key={i} className="ri-star-fill text-[#F6C344] text-sm"></i>
                ))}
              </div>
              <p className="text-gray-600 text-sm leading-relaxed mb-6 italic">&ldquo;{t.text}&rdquo;</p>
              <div className="flex items-center gap-3">
                <div className="w-10 h-10 flex items-center justify-center rounded-full bg-[#1A365D] text-white text-sm font-bold flex-shrink-0">
                  {t.initials}
                </div>
                <div>
                  <div className="font-semibold text-[#1A365D] text-sm">{t.name}</div>
                  <div className="text-gray-400 text-xs">{t.title}</div>
                </div>
                <div className="ml-auto">
                  <span className="bg-[#EEF2F8] text-[#1A365D] text-xs px-2 py-1 rounded-full whitespace-nowrap">{t.date}</span>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}